const BaseModel = require('./BaseModel');

class Aggregates extends BaseModel {
  static basePath = null;
  static dataType = 'aggregates';

  constructor(json={}) {
    super(json);
  }
}

BaseModel.models[Aggregates.dataType] = Aggregates;
module.exports = Aggregates;
